import ACAO from '@/constantes/controle_acesso/ACAO'
import MENU from '@/constantes/controle_acesso/MENU'
import store from '@/stores'

class ControleAcessoServico {
  verificaAcao(nome) {
    let result = true
    const perfil = store.usuarioPerfil
    const email = store.usuarioEmail
    const acao = ACAO.valores.find((a) => a.nome === nome)

    if (acao) {
      if (acao.perfil) {
        if (acao.perfil.permitir) {
          if (!acao.perfil.permitir.includes(perfil)) {
            // existe uma lista de permitir para o perfil e o perfil dele nao está ....
            if (acao.usuario) {
              if (acao.usuario.permitir) {
                if (!acao.usuario.permitir.includes(email)) {
                  // existe uma lista de permitir usuario e o usuario dele não está ....
                  result = false
                } else {
                  // existe uma lista de permitir usuario e o usuario está na lista...
                  result = true
                }
              } else if (acao.usuario.proibir) {
                if (acao.perfil.proibir.includes(email)) {
                  // existe uma lista de proibir usuario e o usuario dele está na lista...
                  result = false
                } else {
                  // existe uma lista de proibir usuario e o usuario dele não está na lista...
                  result = true
                }
              } else {
                // não existe nem lista de permitir e nem de proibir para o usuario, fica com o que valo para o perfil ....
                result = false
              }
            } else {
              // não existe nem lista de permitir e nem de proibir para o usuario, fica com o que valo para o perfil ....
              result = false
            }
          } else {
            // existe uma lista de permitir e o perfil está na lista
            result = true
          }
        } else if (acao.perfil.proibir) {
          if (acao.perfil.proibir.includes(perfil)) {
            // existe uma lista de proibir perfil e o perfil dele está na lista...
            if (acao.usuario) {
              if (acao.usuario.permitir) {
                if (!acao.usuario.permitir.includes(email)) {
                  // existe uma lista de permitir usuario e o usuario dele não está ....
                  result = false
                } else {
                  // existe uma lista de permitir usuario e o usuario está na lista...
                  result = true
                }
              } else if (acao.usuario.proibir) {
                if (acao.perfil.proibir.includes(email)) {
                  // existe uma lista de proibir usuario e o usuario dele está na lista...
                  result = false
                } else {
                  // existe uma lista de proibir usuario e o usuario dele não está na lista...
                  result = true
                }
              } else {
                // usuário não foi encontrado nem na lista de proibir e nem na de permitr, vale a do perfil...
                result = false
              }
            } else {
              // não tem regras para usuário, vale a do perfil...
              result = true
            }
          } else {
            // existe uma lista de proibir perfil e o perfil dele não está nessa lista
            result = true
          }
        } else {
          // não existe nada especificado...
          result = true
        }
      }
    }

    return result
  }

  gerarMenu() {
    const perfil = store.usuarioPerfil
    // let email = store.usuarioEmail
    const resultado = []
    const items = []

    MENU.valores.forEach((item) => {
      const descricao = item.descricao
      const pai = item.pai
      const id = item.id
      const path = item.path
      let podeExibir = true
      const breadcrumb = item.breadcrumb

      if (item.oculto) {
        podeExibir = false
      } else if (item.perfil) {
        if (item.perfil.exibir) {
          if (!item.perfil.exibir.includes(perfil)) {
            podeExibir = false
          }
        } else if (item.perfil.ocultar) {
          if (item.perfil.ocultar.includes(perfil)) {
            podeExibir = false
          }
        }
      }

      if (podeExibir) {
        if (items[pai]) {
          if (!items[pai].items) {
            items[pai].items = []
          }

          if (items[pai].items.indexOf(item) === -1) {
            items[pai].items[items[pai].items.length] = item
            items[id] = item
          }
        } else {
          items[id] = {
            id: id,
            pai: pai,
            descricao: descricao,
            path: path,
            breadcrumb: breadcrumb,
          }
          resultado.push(items[id])
        }
      }
    })

    return resultado
  }
}

export default ControleAcessoServico
